const initialState = {
  isNewBuilding: false,
  id: '',
  building: null,
};

export default initialState;
